import AvatarBirthdayBadge from './AvatarBirthdayBadge';
import container from './AvatarBirthdayBadge.container';

export default container(AvatarBirthdayBadge);
